
export default function wk() {
  return (
    <svg
      width="30"
      height="30"
      x="0"
      y="0"
      version="1.1"
      viewBox="-566.727 -103 204.454 197.209"
      xmlSpace="preserve"
    >
      <g transform="translate(-735.434 -16.966)">
        <path
          fill="#fff"
          stroke="#20201e"
          strokeWidth="3.809"
          d="M295.839-84.13h-50.65v52.933c0 7.793 11.399 14.118 25.452 14.118 14.062 0 25.098-6.325 25.098-14.118 0-.689.095-52.933.095-52.933z"
        ></path>
        <path
          fill="#fff"
          stroke="#20201e"
          strokeWidth="3.809"
          d="M245.187 -84.13H295.836V-38.74399999999999H245.187z"
        ></path>
        <path
          fill="none"
          stroke="#20201e"
          strokeWidth="3.809"
          d="M245.187 -84.13L295.839 -38.748"
        ></path>
        <path
          fill="none"
          stroke="#20201e"
          strokeWidth="3.809"
          d="M295.839 -84.13L245.187 -38.748"
        ></path>
        <path
          fill="#fff"
          stroke="#20201e"
          strokeLinejoin="round"
          strokeWidth="3.809"
          d="M335.92 93.609c-19.706-9.724-41.126-14.837-64.586-14.837s-45.895 5.452-65.606 15.174c19.711 9.724 41.765 15.324 65.222 15.324 23.47.031 45.272-5.915 64.967-15.636z"
        ></path>
        <path
          fill="#fff"
          stroke="#20201e"
          strokeLinejoin="bevel"
          strokeWidth="3.809"
          d="M345.767 60.26a87.585 87.585 0 003.352-3.07c23.817-23.172 29.273-56.198 12.185-73.762-17.095-17.567-50.253-13.015-74.069 10.157-7.115 6.92-12.575 14.723-16.301 22.727-3.724-8.005-9.187-15.807-16.3-22.727-23.815-23.172-56.981-27.724-74.068-10.157C163.473.992 168.928 34.02 192.748 57.19a82.748 82.748 0 003.368 3.077c20.564-7.723 46.559-12.337 74.836-12.337 28.252 0 54.238 4.624 74.782 12.332z"
        ></path>
        <path
          fill="#fff"
          stroke="#20201e"
          strokeWidth="3.809"
          d="M270.953 16.34C274.68 8.335 280.14.534 287.255-6.383c5.798-5.647 12.157-10.179 18.704-13.563-10.857-3.054-22.649-4.73-34.987-4.73-12.345 0-24.15 1.681-35.01 4.74 6.538 3.383 12.895 7.911 18.692 13.553 7.11 6.922 12.553 14.724 16.297 22.715z"
        ></path>
        <path
          fill="#fff"
          stroke="#20201e"
          strokeLinejoin="bevel"
          strokeWidth="3.809"
          d="M345.484 60.26l-.012-.017c-20.554-7.713-46.534-12.32-74.786-12.32-28.276 0-54.27 4.615-74.833 12.337 0 0 9.864 7.726 11.291 13.432 1.426 5.703 2.037 13.881-1.39 20.24 19.708-9.723 42.145-15.175 65.605-15.175 23.012 0 45.166 5.461 64.587 14.836-3.134-6.278-3.14-14.355-1.752-19.9 1.416-5.664 11.295-13.403 11.295-13.403z"
        ></path>
        <path
          fill="#fff"
          stroke="#20201e"
          strokeLinejoin="bevel"
          strokeWidth="3.809"
          d="M205.735 93.955c19.707-9.723 42.145-15.175 65.605-15.175 23.012 0 45.162 5.461 64.586 14.837-1.333-2.683-2.734-9.532-2.51-13.353-19.522-7.674-40.515-11.87-62.387-11.87-22.124 0-43.34 4.283-63.048 12.119.252 7.079-.755 10.634-2.233 13.402z"
        ></path>
        <path d="M280.8004 58.4352L271.079 53.5588 261.3261 58.4352 271.079 63.3117z"></path>
        <path d="M240.6878 61.6443L230.3056 58.4038 221.4651 64.7904 231.8472 68.0308z"></path>
        <path d="M301.4388 61.6443L311.8208 58.4038 320.6613 64.7904 310.2793 68.0308z"></path>
        <ellipse
          cx="270.953"
          cy="-23.958"
          fill="#fff"
          stroke="#20201e"
          strokeWidth="3.809"
          rx="17.93"
          ry="13.239"
        ></ellipse>
      </g>
    </svg>
  );
}

